import { useEffect, useState } from "react";
import { Layout } from "../components/Layout";
import { Card } from "../components/Card";
import { Pill } from "../components/Pill";
import { api } from "../lib/api";

interface AccountSummary {
  account_id: string;
  display_name: string;
  currency: string;
  timezone: string;
}

interface DashboardResponse {
  client: { client_id: string };
  accounts: AccountSummary[];
}

export function ConnectedPage() {
  const [data, setData] = useState<DashboardResponse | null>(null);

  useEffect(() => {
    api<DashboardResponse>("/api/dashboard").then(setData).catch(() => null);
  }, []);

  return (
    <Layout clientId={data?.client.client_id}>
      <div style={{ marginBottom: "var(--space-5)" }}>
        <span className="label">Meta · Connected</span>
        <h1 style={{ marginTop: "6px" }}>You're connected.</h1>
        <p style={{ color: "var(--color-bone-dim)", margin: "8px 0 0" }}>
          The fetcher will pull insights from these ad accounts every six hours (currently every thirty minutes during
          App Review testing).
        </p>
      </div>

      {data && (
        <Card title="Granted ad accounts" actions={<Pill tone="ok">{data.accounts.length}</Pill>}>
          {data.accounts.length === 0 ? (
            <p style={{ color: "var(--color-bone-dim)" }}>No accounts granted yet.</p>
          ) : (
            <ul style={{ margin: 0, paddingLeft: 18, color: "var(--color-bone)" }}>
              {data.accounts.map((a) => (
                <li key={a.account_id} style={{ marginBottom: 6 }}>
                  <strong>{a.display_name}</strong>{" "}
                  <span style={{ color: "var(--color-bone-dim)" }}>
                    — {a.currency}, {a.timezone} ({a.account_id})
                  </span>
                </li>
              ))}
            </ul>
          )}
        </Card>
      )}

      <Card>
        <p>
          <a href="/dashboard">Open dashboard →</a>
          {" "}or{" "}
          <a href="/settings">configure notifications</a>.
        </p>
      </Card>
    </Layout>
  );
}
